(ns measure.reporting-ocp.view.core
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            ["react" :as react]
            [clojure.set :as set]
            [clojure.string :as str]
            [common.ocp.view :refer [defocp ocp]]
            [measure.report-builder.core :refer [entity-names]]
            [measure.reporting-ocp.db.core :as form]
            [measure.reporting-ocp.view.tabs.delivery :refer [delivery-tab]]
            [measure.reporting-ocp.view.tabs.general :refer [general-tab]]
            [measure.reporting-ocp.view.tabs.type :refer [type-tab]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]
            [uix.re-frame :refer [use-subscribe]]))

(defocp report-crud-ocp :report/crud
  {:width "40%"}
  []
  (let [{:keys [mode entity] :as _meta} (use-subscribe [:form.report/meta []])
        adset-ids (use-subscribe [:form.report/value :adset-ids])
        entity-name (get entity-names entity)
        action-label (str/capitalize (str (some-> mode name) " " entity-name))
        [active-tab set-active-tab] (react/useState :general)
        [visited-tabs set-visited-tabs] (react/useState #{:general})

        next-tab (fn [active-tab]
                   (case active-tab
                     :general :type
                     :type :delivery
                     :delivery nil))

        errors-in-general-tab (use-subscribe [:form.report/error-in-fields? [[:name] [:adset-ids] [:timezone] [:date-range] [:date-phrase]]])
        errors-in-type-tab (use-subscribe [:form.report/error-in-fields? [[:type] [:fields]]])
        errors-in-delivery-tab (use-subscribe [:form.report/error-in-fields? [[:delivery-valid?] [:email]]])
        valid-adset-workflows (form/use-valid-adset-workflows)]
    ($ ocp
       {:title action-label
        :on-submit (fn []
                     (when valid-adset-workflows
                       (rf/dispatch [:form.report/submit (fn []
                                                           (let [next-tab (next-tab active-tab)]
                                                             (when next-tab
                                                               (set-active-tab next-tab)
                                                               (set-visited-tabs (conj visited-tabs next-tab)))
                                                             next-tab))])))
        :header ($ Tabs {:value (name active-tab)
                         :on-change (fn [_e v]
                                      (set-active-tab (keyword v))
                                      (set-visited-tabs (conj visited-tabs (keyword v))))
                         :sx #js {:px 3
                                  :backgroundColor "grey.90"}}
                   ($ Tab {:label "1. General"
                           :value "general"
                           :icon (when errors-in-general-tab
                                   ($ Icon {:color "warning"} "warning"))
                           :iconPosition "end"
                           ;; Go back to default height, adding icon changed this.
                           :sx #js {:minHeight "48px"}})
                   ($ Tab {:label "2. Type"
                           :disabled (or (empty? adset-ids) (not valid-adset-workflows))
                           :value "type"
                           :icon (when errors-in-type-tab
                                   ($ Icon {:color "warning"} "warning"))
                           :iconPosition "end"
                           :sx #js {:minHeight "48px"}})
                   ($ Tab {:label "3. Delivery"
                           :disabled (or (not (set/subset? #{:general :type} visited-tabs))
                                         (not valid-adset-workflows))
                           :value "delivery"
                           :icon (when errors-in-delivery-tab
                                   ($ Icon {:color "warning"} "warning"))
                           :iconPosition "end"
                           :sx #js {:minHeight "48px"}}))
        :footer ($ Button {:variant "contained"
                           :type "submit"}
                   (if (nil? (next-tab active-tab))
                     action-label
                     "Continue →"))}
       (case active-tab
         :type ($ type-tab)
         :delivery ($ delivery-tab)
         ($ general-tab {:entity entity})))))
